import PlaceProductFromFormModule from './module';

const PlaceProductFromFormContainer = () => {
    return <PlaceProductFromFormModule/>;
};

export {PlaceProductFromFormContainer as PlaceProductFromForm};